import { z } from 'zod';

export const SignalListSortFieldSchema = z.enum([
  'createdAt',
  'category',
  'confidence',
  'description',
  'status',
  'stage',
  'source',
  'appWide',
  'domain',
  'endpoint',
  'execution',
  'finding',
  'asset',
]);

export type SignalListSortField = z.infer<typeof SignalListSortFieldSchema>;

export const SignalListGroupByFieldSchema = z.enum([
  'status',
  'stage',
  'category',
  'source',
  'endpoint',
  'execution',
  'finding',
  'asset',
]);

export type SignalListGroupByField = z.infer<
  typeof SignalListGroupByFieldSchema
>;

export const SIGNAL_LIST_EMPTY_GROUP_KEY = '__none__';

export const SignalListGroupEndpointSchema = z.object({
  url: z.string(),
  method: z.string().nullable(),
  graphqlOperationName: z.string().nullable(),
});

export type SignalListGroupEndpoint = z.infer<
  typeof SignalListGroupEndpointSchema
>;

export const SignalListGroupCountSchema = z.object({
  key: z.string(),
  count: z.number(),
  label: z.string().optional(),
  endpoint: SignalListGroupEndpointSchema.optional(),
});

export type SignalListGroupCount = z.infer<typeof SignalListGroupCountSchema>;
